import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import WarningIcon from "@mui/icons-material/Warning";
import BottomTab from "../../../../components/pagination/BottomTab";

const LIMIT = 20;

function ShouldBePaid() {
  const navigate = useNavigate();
  const [payment, setpayment] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);

  const getData = useCallback((pageNum: number) => {
    baseUrl
      .get("payment/getDuePayment", { params: { page: pageNum, limit: LIMIT } })
      .then((response) => {
        setpayment(response.data.data);
        setCount(response.data.count ?? 0);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    getData(page);
  }, [page, getData]);

  const onPageChange = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 bg-red-100 dark:bg-red-900/40 rounded-lg flex items-center justify-center">
          <WarningIcon className="text-red-600 dark:text-red-400" sx={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="text-sm font-bold text-slate-800 dark:text-slate-200">Due Payments</h3>
          <p className="text-xs text-slate-500 dark:text-slate-400">{count} pending</p>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-red-100 dark:border-red-900/50 overflow-hidden">
        <table className="w-full">
          <thead className="bg-red-50 dark:bg-red-900/30 border-b border-red-100 dark:border-red-900/50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Invoice</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Patient</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Total</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Discount</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Card</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Cash</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Bank</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">paid</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Due</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-red-600 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
            {payment.map((item: any, index) => (
              <tr
                key={index}
                onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
                className="hover:bg-red-50/50 dark:hover:bg-red-900/20 cursor-pointer transition-colors"
              >
                <td className="px-3 py-2 text-xs font-medium text-indigo-600 dark:text-indigo-400">{item?.invoiceNo}</td>
                <td className="px-3 py-2 text-xs font-medium text-slate-800 dark:text-slate-200">{item?.fullName}</td>
                <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">{item?.total}</td>
                <td className="px-3 py-2 text-xs text-orange-600 dark:text-orange-400">{item?.discount}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600 dark:text-emerald-400">{item?.card}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600 dark:text-emerald-400">{item?.cash}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600 dark:text-emerald-400">{item?.bankTransfer}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600 dark:text-emerald-400">{item?.paid}</td>
                <td className="px-3 py-2">
                  <span className="px-2 py-0.5 bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 rounded-md text-xs font-semibold">
                    {item?.due}
                  </span>
                </td>
                <td className="px-3 py-2 text-xs text-slate-500 dark:text-slate-400">{item?.updatedAt?.split("T")[0]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {payment.map((item: any, index) => (
          <div
            key={index}
            onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
            className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-red-100 dark:border-red-900/50 p-3 cursor-pointer"
          >
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-medium text-xs text-indigo-600 dark:text-indigo-400">{item?.invoiceNo}</span>
              <span className="px-2 py-0.5 bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 rounded-md text-xs font-semibold">
                Due: {item?.due}
              </span>
            </div>
            <h3 className="font-semibold text-xs text-slate-800 dark:text-slate-200">{item?.patientData?.fullName}</h3>
            <div className="flex items-center justify-between mt-1.5 text-xs">
              <span className="text-slate-500 dark:text-slate-400">Total: {item?.total}</span>
              <span className="text-emerald-600 dark:text-emerald-400">Paid: {item?.card + item?.cash}</span>
            </div>
          </div>
        ))}
      </div>

      {count > LIMIT && (
        <BottomTab count={count} onPageChange={onPageChange} />
      )}
    </div>
  );
}

export default ShouldBePaid;
